import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment.dev';

interface AuthConfig {
  tenant: string;
  clientId: string;
}

interface ClientRuntimeConfig {
  riskApiAddress: string;
  authConfig: AuthConfig;
}

@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {
  private config: ClientRuntimeConfig | null = null;

  public async load(): Promise<void> {
    try {
      const response = await fetch('/client-config', { cache: 'no-store' });

      if (response.ok) {
        const runtimeConfig = await response.json();

        if (runtimeConfig && runtimeConfig.riskApiAddress && runtimeConfig.authConfig) {
          this.config = runtimeConfig as ClientRuntimeConfig;
          return;
        }
      }
    } catch {
      // Fallback to Angular environment values when runtime config is unavailable.
    }

    this.config = {
      riskApiAddress: environment.RiskApiAddress,
      authConfig: environment.authConfig
    };
  }

  public getRiskApiAddress(): string {
    if (this.config && this.config.riskApiAddress) {
      return this.config.riskApiAddress;
    }

    return environment.RiskApiAddress;
  }

  public getAuthConfig(): AuthConfig {
    if (this.config && this.config.authConfig) {
      return this.config.authConfig;
    }

    return environment.authConfig;
  }
}